import { tokens } from '../../tokens/underlyingTokens';
import type { VToken } from '../../types';

export const baseSepolia: VToken[] = [
  {
    chainId: 84532,
    address: '0x776f14D624aBdAfa912d6Cd0864976DdaF5Ca4a7',
    decimals: 8,
    symbol: 'vcbBTC_Core',
    underlyingToken: tokens[84532][2],
  },
  {
    chainId: 84532,
    address: '0x436E5A07F58AAA86277e8b992bC3e596eC423d09',
    decimals: 8,
    symbol: 'vWETH_Core',
    underlyingToken: tokens[84532][1],
  },
  {
    chainId: 84532,
    address: '0xA31D67c056Aadc2501535f2776bF1157904f810e',
    decimals: 8,
    symbol: 'vUSDC_Core',
    underlyingToken: tokens[84532][3],
  },
  {
    chainId: 84532,
    address: '0xF9d609ba31724E199ccaacaD3e3e7ED8462C20C5',
    decimals: 8,
    symbol: 'vwsuperOETHb_Core',
    underlyingToken: tokens[84532][5],
  },
  {
    chainId: 84532,
    address: '0x40A30E1B01e0CF3eE3F22f769b0E437160550eEa',
    decimals: 8,
    symbol: 'vwstETH_Core',
    underlyingToken: tokens[84532][6],
  },
];
